import drushim_lodash from 'lodash'
import STSSearchTypes from '@/lib/enums/STSSearchTypes'
import { apiFlags as offerSearchAutoSuggest } from '@/lib/enums/apiFlags';


/**Returns the values that are relevant to the search from apiFlags */
export const returnRelevantSearchFlags = ()=> {
    const relevantFlags = offerSearchAutoSuggest.filter(obj=> obj.status === true);
    const strings = relevantFlags.map(obj=> obj = obj.value );
    return strings;
}



export const api = {
    offerSearch: process.env.baseUrl + '/offerSearchAutoSuggest/'
}

export function request(options = {}, axios)
{
    return axios(options)
}

function returnFetchData(req)
{
    return req.then(res => res.data)
}
export function webApiRequest(axios, options = {})
{
    const defaults = {
        responseType: 'json'
    }
    options = drushim_lodash.assign({}, defaults, options)

    return request(axios, options)
}

export function loadSuggestions(options = {}, axios)
{
    const data = {
        application: 'drushim',
        country: 'il',
        environment: 'live',
        searchType: 'offerSearchAutoSuggest',
        queryItems: [],
        mainResultParameter: {
            max: 15,
            offset: 0,
            sortings: [],
            parameters: [],
            options: [],
            infos: []
        },
        resultParameters: {},
        cookies: [],
        httpRequestInfo: {},
        parameters: [],
        options: [],
        infos: []
    }

    const defaults = {
        method: 'post',
        url: api.offerSearch,
        data: data,
        responseType: 'json'
    }
    options = drushim_lodash.merge({}, defaults, options)
    return returnFetchData(request(options, axios))
}

export const jobsSearch = drushim_lodash.flow(
    options => drushim_lodash.assign({}, options, { url: webApi.jobsSearch }),
    webApiRequest,
    returnFetchData
)

/**
 * Transform api response to entry
 * @example
 * const row = ['display', 'category', 4, 5, 9, 'typeRetiveId', 10, 'category', 'parentDisplayString', 6, 'lastUpdate', true]
 * const settings = { columnNames = ['displayString', 'type', ...], columnPosition = { displayString: 0, type: 1, ... }}
 *
 * let result = rowToEntry(row, settings);
 *
 * result = {
 * displayString: column[0], // 'display'
 * type: column[1], // category
 * score: column[2],
 * frequency: column[3],
 * relativeFrequency: column[4],
 * typeRelativeId: column[5],
 * parentId: column[6],
 * parentType: column[7],
 * parentDisplayString: column[8],
 * hitCount: column[9],
 * lastUpdate: column[10],
 * selected: column[11],
 * drushim_region_ids: column[12]
 * }
 * @param {Array} row
 * @param {object} settings     settings
 */
export function rowToEntry(row, settings)
{
    return drushim_lodash.transform(
        settings.columnNames,
        (entry, name) =>
        {
            const index = settings.columnPosition[name]
            entry[name] = row[index]
        }, {}
    )
}

/**
 * Convert `resultList.rows` from server to Entry
 * @see IEntry
 * @param {object} resultList - server result model
 * @returns {object[]} - list of entries
 */
export function getEntries(resultList)
{
    const entries = drushim_lodash.get(resultList, 'rows', []).map(row =>
        rowToEntry(row, resultList)
    )

    return entries
}

/**
 * Get items filtered for unique items using categories as the display value
 * @param {object[]} items
 */
export function uniqByCategory(items)
{
    return drushim_lodash.uniqBy(
        drushim_lodash.orderBy(items, [o => sortByType(o.type)]),
        'displayString'
    )
}

export const getItems = drushim_lodash.flow([getEntries, sortByScoreDesc, uniqByCategory])

function sortByScoreDesc(items)
{
    return drushim_lodash.orderBy(items, [o => parseFloat(o.score)], ["desc"])
}


function sortByType(type)
{
    let score = 100;

    if (drushim_lodash.has(STSSearchTypes, type))
    {
        return STSSearchTypes[type];
    }

    return score
}
